import {Injectable} from '@angular/core';
import {DetaillineDTOModel} from '../models/detaillineDTO.model';
import {DocumentModel} from '../models/document.model';
import {GeneralService} from './general.service';

@Injectable({
    providedIn: 'root'
})
export class StockTakeHelperService {

    constructor(private generalService: GeneralService) {
    }


    addItemToStockCount(stockCount: DocumentModel, product: DetaillineDTOModel, qty: number) {
        if (!this.productAlreadyCounted(stockCount, product, qty)) {
            const tempProduct = JSON.parse(JSON.stringify(product));
            tempProduct.qty = +qty;
            stockCount.detailLines.push(tempProduct);
            this.generalService.createToast('Product added to the count');
        }
    }

    private productAlreadyCounted(stockCount: DocumentModel, product: DetaillineDTOModel, qty: number): boolean {
        for (const line of stockCount.detailLines) {
            if (line.plu && product.plu && line.plu === product.plu) {
                line.qty += +qty as number;
                this.generalService.createToast('Product updated');
                return true;
            }
        }
        return false;
    }
}
